const Styles = {
  typography: {
    color: "#0000FF",
    marginBottom: 25,
    fontSize: 22,
    fontWeight: 500,
  },

  customTextFieldName: {
    width: "100%",
    marginBottom: "10px",
  },

  customTextFieldSecondary: {
    width: "85%",
    marginBottom: "10px",
  },
  customTextFieldSecondarytwo: {
    width: "85%",
    marginBottom: "10px",
    marginLeft: "40px",
  },
  customTextFieldNameField: {
    width: "100%",
    marginBottom: "10px",
  },
  gridContainerStyle: {
    marginTop: 8,
  },
  gridStyle: {
    marginTop: 12,
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "3.75rem",
  },
  name: {
    gridColumn: "1 / 3",
  },
  action: {
    marginTop: "3rem",
    display: "flex",
    width: "40%",
    gap: "2rem",
  },
};

export default Styles;
